module.exports = __webpack_public_path__ + "static/media/i-web.0e8f6011.svg";